import React from "react";
import TopBar from "@/components/TopBar";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#050505] text-white flex flex-col">
      <TopBar />
      <div className="flex-1 max-w-3xl mx-auto px-6 py-10 text-sm leading-relaxed text-[#c0c0c0]">
        <div className="micro-label">/ legal</div>
        <h1 className="font-heading text-3xl mt-1 mb-8">Terms of Service</h1>

        <section className="space-y-4">
          <h2 className="font-heading text-lg text-white mt-6">1. Acceptance</h2>
          <p>
            By accessing or using Momentum Terminal at <em>tracker.piratetrader.com</em> (the
            “Service”), you agree to these Terms of Service and to our{" "}
            <Link to="/disclaimer" className="underline hover:text-white">Disclaimer</Link>.
            If you do not agree, do not use the Service.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">2. Eligibility</h2>
          <p>
            You must be at least 18 years old and legally able to enter into contracts. You represent
            that all information you provide is accurate.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">3. Account</h2>
          <p>
            You are responsible for maintaining the confidentiality of your account credentials and
            for all activity that occurs under your account. Notify us immediately of any unauthorized
            use.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">4. Subscription & payments</h2>
          <p>
            Pro tier access is provided via one-time payment or subscription processed by Stripe.
            Founding Member lifetime access is a one-time, non-refundable purchase granting Pro
            features for the operational life of the Service. Regular Pro subscriptions renew on the
            stated cadence unless cancelled. Refunds are handled on a case-by-case basis.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">5. Prohibited use</h2>
          <p>
            You may not: (a) redistribute, resell, or systematically extract Service data; (b) reverse
            engineer the Service; (c) use the Service to violate any law or infringe any right; (d)
            attempt to breach or bypass Service security.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">6. Third-party data</h2>
          <p>
            Market data is provided by third parties. We do not guarantee its accuracy or availability.
            Third-party services may impose their own terms.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">7. AI-generated content</h2>
          <p>
            AI outputs are generated by third-party language models. We do not warrant their
            correctness. AI content must not be treated as professional advice.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">8. No warranty</h2>
          <p>
            The Service is provided “AS IS” without warranties of any kind, express or implied,
            including but not limited to merchantability, fitness for a particular purpose, and
            non-infringement.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">9. Limitation of liability</h2>
          <p>
            To the maximum extent permitted by law, the operators' aggregate liability arising out
            of or relating to your use of the Service will not exceed the amount you paid for the
            Service in the twelve months preceding the claim, or $100, whichever is greater.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">10. Termination</h2>
          <p>
            We may suspend or terminate access at any time for violation of these Terms. You may
            close your account at any time.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">11. Changes</h2>
          <p>
            We may update these Terms at any time. Continued use of the Service after changes
            constitutes acceptance.
          </p>

          <h2 className="font-heading text-lg text-white mt-6">12. Contact</h2>
          <p>Questions: reach the operators through the piratetrader.com blog.</p>

          <p className="text-xs text-[#555] mt-8">Last updated: {new Date().toISOString().slice(0,10)}</p>
        </section>
      </div>
      <Footer />
    </div>
  );
}
